/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react/macro"
import React from "react"
import UndergroundBindingQuestionTable from "./UndergroundBindingQuestionTable"

const componentStyle = css`
    margin-top: 15px;    
`
class UndergroundBindingQuestions extends React.Component{
    
    render(){
        const { applicationsContainer } = this.props
        const questionSets = applicationsContainer.state.undergroundBindingQuestions

        return(
            <div css={componentStyle}>
                <div className="row">
                    <div className="col">
                        <h3>Underground Storage Tanks</h3>
                        {questionSets.map((questionSet, index)=>(
                            ((questionSet.tanks.length > 0) &&
                                <UndergroundBindingQuestionTable key={index}
                                                                 questionSet={questionSet}
                                                                 applicationsContainer = {applicationsContainer} />
                            )
                        ))}                        
                    </div>
                </div>
            </div>
        )
    }   
}

export default UndergroundBindingQuestions